import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LangProvider } from "../contexts/LangContext";
import { LoginPage } from "../pages/LoginPage";

export const Route = createFileRoute("/login")({
  head: () => ({
    meta: [{ title: "Kirish — Lotin.uz" }],
    htmlProps: { lang: "uz-Latn" },
  }),
  component: Login,
});

function Login() {
  const { i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = "uz-Latn";
    if (i18n?.changeLanguage) i18n.changeLanguage("default");
  }, [i18n]);
  return (
    <LangProvider lang={"uz-Latn"}>
      <LoginPage />
    </LangProvider>
  );
}
